import BasicAccordion from "../../atoms/accordion";
import { useDispatch, useSelector } from 'react-redux';
import { getViews } from "../../../store/views/selectors";
import { useState } from "react";
import { handleSnackBar } from "../../../store/global/actions";
import DeleteActionAlert from "../alerts/DeleteActionAlert"

export default function TableActions(props) {
    const { tableAction, tableLevel, index, setAction, selectedWidget } = props;

    const dispatch = useDispatch();

    const selectedView = useSelector(getViews)
    const [updatedWidget, setUpdatedWidget] = useState({})
    const [openDeleteAlert, setOpenDeleteAlert] = useState(false)

    const onDelete = () => {
        let selectedItem = { ...selectedWidget }
        if (tableLevel) {
            if (selectedItem?.tableactions && selectedItem.tableactions.length > 0) {
                let filteredActions = selectedItem?.tableactions.filter(tAction => tAction.id !== tableAction.id);
                selectedItem.tableactions = [...filteredActions]
            }
        }
        else {
            let dropDownChild = selectedItem?.children.find(field => field.type === 'drop-down')

            if (dropDownChild !== undefined && dropDownChild.children !== undefined && dropDownChild.children.length > 0) {
                const index = selectedItem.children.findIndex(item => item.type === "drop-down");
                if (index !== -1) {
                    let filteredRowActions = selectedItem?.children[index]?.children.filter(rAction => rAction.id !== tableAction.id)
                    selectedItem.children[index].children = [...filteredRowActions]
                }
            }
        }

        setUpdatedWidget(selectedItem);
        setOpenDeleteAlert(true);
    }

    const onClose = () => {
        setAction({});
        setOpenDeleteAlert(false);
    };

    const onCompletion = () => {
        dispatch(handleSnackBar({ open: true, message: 'Action deleted', severity: 'success' }));
        setAction({});
        setOpenDeleteAlert(false);
    }


    return (
        <>
            {openDeleteAlert && <DeleteActionAlert updatedWidget={updatedWidget} view={selectedView} onClose={onClose} onCompletion={onCompletion} />}
            <BasicAccordion item={tableAction} onDelete={onDelete} key={tableAction.id} class="table-action-accordion" index={index}>
                {props.children}
            </ BasicAccordion >
        </>

    )

}
